class NavComponent extends HTMLElement {
    #status = false;

    #elToggler = this.querySelectorAll('.js-nav-expander');

    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        for (const el of this.#elToggler) {
            el.addEventListener('click', () => {
                this.#status = !(this.#status);
                this.update();
            });
        }
    }

    update() {
        this.classList.toggle('nav--expanded', this.#status);
    }
}

customElements.define('ent-nav', NavComponent);